/*
 * Copyright (c) 2024 SmartWifi - All Rights Reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential. No warranty, explicit or implicit provided. In
 * no event will the author be liable for any claim or damages.
 */

import makeRequest from "../MakeRequest";
import {
  parseClientData,
  parseClientDataNewToken,
  parseClientList,
  parseClientListNewToken,
  parseDataConfig
} from "./Parsers";

export const requestClientData = (attrs) => {
  // prepare payload
  const { clientId, guestId} = attrs;
  const payload = { client_id: clientId, guest_id: guestId };

  // make request
  makeRequest({
    ...attrs,
    request: {
      route: "guest/data/get",
      payload: payload,
      parser: parseClientData
    }
  });
};

export const requestUpdateClientData = (attrs) => {
  // prepare payload
  const { clientId, guestId, birthday, timezone, language, name, email, phoneNumber} = attrs;
  const payload = {
    client_id: clientId,
    guest_id: guestId,
    birthday: birthday,
    timezone: timezone,
    language: language,
    name: name,
    email: email,
    phone_number: phoneNumber,
  };

  // make request
  makeRequest({
    ...attrs,
    request: {
      route: "guest/data/update",
      payload: payload,
      parser: parseClientData
    }
  });
};

export const requestOptInClientData = (attrs) => {
  // prepare payload
  const { clientId, guestId } = attrs;
  const payload = { client_id: clientId, guest_id: guestId };

  // make request
  makeRequest({
    ...attrs,
    request: {
      route: "guest/data/optin",
      payload: payload,
      parser: parseClientDataNewToken
    }
  });
};

export const requestOptOutClientData = (attrs) => {
  // prepare payload
  const { clientId, guestId } = attrs;
  const payload = { client_id: clientId, guest_id: guestId };

  // make request
  makeRequest({
    ...attrs,
    request: {
      route: "guest/data/optout",
      payload: payload,
      parser: parseClientDataNewToken
    }
  });
};

export const requestDeleteClientData = (attrs) => {
  // prepare payload
  const { clientId, guestId } = attrs;
  const payload = { client_id: clientId, guest_id: guestId };

  // make request
  makeRequest({
    ...attrs,
    request: {
      route: "guest/data/delete",
      payload: payload,
      parser: parseClientListNewToken
    }
  });
};

export const requestClientList = (attrs) => {
  // make request (no payload needed)
  makeRequest({
    ...attrs,
    request: {
      route: "guest/data/accounts",
      payload: {},
      parser: parseClientList
    }
  });
};

export const requestDataConfig = (attrs) => {
  const { customDomain } = attrs;
  const payload = { custom_domain: customDomain };

  makeRequest({
    ...attrs,
    request: {
      route: "guest/data/config",
      payload: payload,
      parser: parseDataConfig
    }
  });
};
